import { ChainId } from 'constants/chains'
import JSBI from 'jsbi'
import { constructSameAddressMap } from 'utils/constructSameAddressMap'

// export const INIT_CODE_HASH = '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f'

// Map of chain IDs to their specific INIT_CODE_HASH values
export const INIT_CODE_HASHES = {
  ...constructSameAddressMap('0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f'),
  [ChainId.ABSTRACT]: '0x010005210caf9c20af7fd4620644b86f792655e821edabc4c8204a489fc1a1f3',
  [ChainId.ABSTRACT_TESTNET]: '0x010005210caf9c20af7fd4620644b86f792655e821edabc4c8204a489fc1a1f3',
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const FIVE = JSBI.BigInt(5)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)
